module.exports = __webpack_public_path__ + "media/images/emblems/Blason_mont-noble-3f0b2f9055ed04f28c968754c61115ae.svg";